/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { getIsXFA } from "selectors/documentSelectors";

export const getHasDigSigFromMetadata = stores => stores.documentStore.hasDigSig;

export const getEnableDigSig = stores => {
  if (stores.digSigStore.enableDigSig && !getIsXFA(stores) && getHasDigSigFromMetadata(stores)) {
    return true;
  }
  return false;
};

export const getDigSigStatus = stores => stores.digSigStore.digSigFetchStatus;

export const getSignaturesData = stores => stores.digSigStore.signaturesData;

export const getPdfValidationSummary = stores => stores.digSigStore.pdfValidationSummary;

export const getValidateDigSigButtonState = stores => stores.digSigStore.validateDigSigButtonState;

export const getDigSigRHPVisibility = stores => stores.digSigStore.showDigSigRHP;

export const getDigSigBannerVisibility = stores => stores.digSigStore.digSigBannerVisibility;

export const getValidationAttemptCount = stores => stores.digSigStore.validationAttempt;

export const getDigSigBannerId = stores => stores.digSigStore.digSigBannerId;
